// A villager window and the scan both name the villager by its career's 1.8 translation key.
export const VILLAGER_CAREER_KEYS: Record<string, string> = {
    'entity.Villager.farmer': 'VILLAGER_TRADING_CAREER_FARMER',
    'entity.Villager.fisherman': 'VILLAGER_TRADING_CAREER_FISHERMAN',
    'entity.Villager.shepherd': 'VILLAGER_TRADING_CAREER_SHEPHERD',
    'entity.Villager.fletcher': 'VILLAGER_TRADING_CAREER_FLETCHER',
    'entity.Villager.librarian': 'VILLAGER_TRADING_CAREER_LIBRARIAN',
    'entity.Villager.cleric': 'VILLAGER_TRADING_CAREER_CLERIC',
    'entity.Villager.armor': 'VILLAGER_TRADING_CAREER_ARMOR',
    'entity.Villager.weapon': 'VILLAGER_TRADING_CAREER_WEAPON',
    'entity.Villager.tool': 'VILLAGER_TRADING_CAREER_TOOL',
    'entity.Villager.butcher': 'VILLAGER_TRADING_CAREER_BUTCHER',
    'entity.Villager.leather': 'VILLAGER_TRADING_CAREER_LEATHER',
};
